<template>
	<form class="detail" @submit.prevent="submit">
		<div class="detail__default">
			<div class="detail__default-section1">
				<ManagingSection
					:noPaddingTop="true"
					:columnCount="2"
					header="기본 정보"
				>
					<ManagingBox title="이벤트번호" contsPadding="6px">
						{{ id || '자동생성' }}
					</ManagingBox>
					<ManagingBox title="이벤트기간" contsPadding="6px">
						{{ calendar_on }}
					</ManagingBox>
				</ManagingSection>
				<ManagingSection :splice="true">
					<ManagingBox title="이벤트명" contsPadding="6px">
						<TextCounter
							v-model="title"
							:maxLength="20"
							class="detail__text-counter"
						/>
					</ManagingBox>
					<ManagingBox title="노출상태" contsPadding="6px">
						{{ is_display ? '노출' : '미노출' }}
					</ManagingBox>
				</ManagingSection>
				<ManagingSection :splice="true" :columnCount="2">
					<ManagingBox
						:title="`일반출석도장<br>${getLimitStr('stamp')}`"
						contsPadding="6px"
						contsHeight="265px"
					>
						<ImageUploader
							group="stamp"
							:imageSizeLimit="stampImgLimit"
							:imageSrc="getImgSrc('calendar_stamp_normal_image')"
							@upload="
								uploadImg($event, 'calendar_stamp_normal_image')
							"
							@cancel="addRemoveImg"
						/>
					</ManagingBox>
					<ManagingBox
						:title="`대체출석도장<br>${getLimitStr('stamp')}`"
						contsPadding="6px"
						contsHeight="265px"
					>
						<ImageUploader
							group="stamp"
							:imageSizeLimit="stampImgLimit"
							:imageSrc="
								getImgSrc('calendar_stamp_alternative_image')
							"
							@upload="
								uploadImg(
									$event,
									'calendar_stamp_alternative_image'
								)
							"
							@cancel="addRemoveImg"
						/>
					</ManagingBox>
					<ManagingBox title="오늘일자 컬러" contsPadding="6px">
						<input
							v-model="calendar_today_color"
							type="color"
							class="detail__color-input"
						/>
					</ManagingBox>
					<ManagingBox title="캘린더 컬러" contsPadding="6px">
						<input
							v-model="calendar_color"
							type="color"
							class="detail__color-input"
						/>
					</ManagingBox>
				</ManagingSection>
			</div>
			<div class="detail__default-section2">
				<ManagingSection :noPaddingTop="true">
					<ManagingBox
						:title="`캘린더 배경<br>${getLimitStr('bg')}`"
						contsPadding="6px"
						contsHeight="492px"
					>
						<ImageUploader
							group="stamp"
							:imageSizeLimit="bgImgLimit"
							:imageSrc="getImgSrc('calendar_background_image')"
							@upload="
								uploadImg($event, 'calendar_background_image')
							"
							@cancel="addRemoveImg"
						/>
					</ManagingBox>
				</ManagingSection>
			</div>
			<div class="detail__default-section3">
				<ManagingSection :noPaddingTop="true">
					<ManagingBox
						title="이벤트내용"
						contsPadding="6px"
						contsHeight="492px"
					>
						<TextEditor
							:width="480"
							:height="480"
							v-model="content"
						/>
					</ManagingBox>
				</ManagingSection>
			</div>
		</div>
		<ManagingSection :columnCount="2" header="참여 정보">
			<ManagingBox title="당첨 발표" contsPadding="6px">
				<DateBox v-model="reward_on" type="date" />
			</ManagingBox>
			<ManagingBox title="등록된 댓글" contsPadding="6px">
				<button
					v-if="isModify"
					type="button"
					class="btn"
					v-text="'댓글 리스트'"
					@click="toggleCommentModal"
				/>
			</ManagingBox>
			<ManagingBox title="당첨 분류" contsPadding="6px">
				<template v-for="(item, idx) in stamp_condition_list">
					<ConditionItem
						v-show="!item.delete"
						:key="idx"
						:id="idx"
						:date="String(item.sum_stamp)"
						:title="item.title"
						:headcount="String(item.sum_winner)"
						:deletable="stamp_condition_list.length > 3"
						:addable="stamp_condition_list.length === 1 + idx"
						@input="conditionInput"
						@delete="conditionDelete"
						@add="conditionAdd"
					/>
				</template>
			</ManagingBox>
			<ManagingBox title="댓글 영역<br>고정 노출 문구" contsPadding="6px">
				<TextCounter
					v-model="comment_placeholder"
					:useTextarea="true"
					:maxLength="150"
				/>
			</ManagingBox>
		</ManagingSection>
		<ManagingSection :splice="true">
			<ManagingBox title="증정 제품" contsPadding="6px">
				<ProductSearcher2 @change="selectPdt" />
				<table class="table-main detail__pdt-list">
					<thead>
						<tr>
							<th v-for="th in pdtThList" :key="th" v-text="th" />
						</tr>
					</thead>
					<tbody>
						<tr v-if="!parsedPdtList.length">
							<td
								:colspan="pdtThList.length"
								v-text="'선택된 제품이 없습니다.'"
							/>
						</tr>
						<tr v-for="item in parsedPdtList" :key="item.idProduct">
							<td
								:class="{ 'color-orange': item.temp }"
								v-text="item.idProduct"
							/>
							<td>
								<Thumbnail
									data-app
									:src="item.filePath"
									:width="40"
								/>
							</td>
							<td v-text="item.brandTitle" />
							<td v-text="item.productTitle" />
							<td
								:class="{ 'font-red': !item.isDisplay }"
								v-text="item.isDisplayText"
							/>
							<td
								:class="{ 'font-red': item.isDiscontinue }"
								v-text="item.isDiscontinueText"
							/>
							<td>
								<VIcon
									class="detail__pdt-delete-button"
									v-text="'mdi-minus-circle'"
									@click="removePdt(item.idProduct)"
								/>
							</td>
						</tr>
					</tbody>
				</table>
			</ManagingBox>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button
				type="submit"
				class="btn-main blue"
				v-text="isModify ? '수정' : '등록'"
			/>
			<router-link
				v-if="isModify"
				:to="`/event/stamp/${id}/winner`"
				class="btn-main"
				>당첨자 선정</router-link
			>
			<button
				type="button"
				class="btn-main blue bordered"
				@click="cancel"
				v-text="'취소'"
			/>
		</div>
	</form>
</template>
<script>
	import moment from 'moment';
	import { imageRemove } from '@/util.js';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import ImageUploader from '@/components/ImageUploader.vue';
	import TextCounter from '@/components/TextCounter.vue';
	import TextEditor from '@/components/TextEditor.vue';
	import DateBox from '@/components/DateBox.vue';
	import ConditionItem from '@/components/stamp/ConditionItem.vue';
	import ProductSearcher2 from '@/components/ProductSearcher2.vue';
	import Thumbnail from '@/components/Thumbnail.vue';
	import router from '../../router';

	export default {
		name: 'StampDetail',
		components: {
			ManagingSection,
			ManagingBox,
			ImageUploader,
			TextCounter,
			TextEditor,
			DateBox,
			ConditionItem,
			ProductSearcher2,
			Thumbnail,
		},
		props: {
			id: {
				type: Number,
				default: null,
			},
			detail: {
				type: Object,
				default: null,
			},
		},
		data() {
			const idStamp = this.id;
			const calendar_on = this.$route.params.idStamp;
			const lastDate = Number(
				moment(calendar_on, 'YYYY-MM-DD').endOf('month').format('DD')
			);
			return {
				idStamp,
				calendar_on,
				removeImgList: [],
				bgImgLimit: {
					width: 1125,
					height: 1998,
					type: 'fit',
					previewWidth: 240,
				},
				stampImgLimit: { width: 114, height: 114, type: 'fit' },
				calendar_background_image: '',
				calendar_stamp_normal_image: '',
				calendar_stamp_alternative_image: '',
				title: '',
				is_display: 1,
				calendar_today_color: '#FFFFFF',
				calendar_color: '#000000',
				content: '',
				reward_on: moment(calendar_on, 'YYYY-MM-DD')
					.add(1, 'M')
					.date(2)
					.format('YYYY-MM-DD'),
				conditionKeyMap: {
					date: 'sum_stamp',
					title: 'title',
					headcount: 'sum_winner',
				},
				stamp_condition_list: [
					{
						sum_stamp: lastDate,
						title: '개근상',
						sum_winner: 5,
					},
					{
						sum_stamp: 20,
						title: '아차상',
						sum_winner: 10,
					},
					{
						sum_stamp: 10,
						title: '참가상',
						sum_winner: 15,
					},
				],
				comment_placeholder: '',
				stamp_product_list: [],
				pdtThList: [
					'제품항번',
					'이미지',
					'브랜드명',
					'제품명',
					'노출',
					'단종',
					'제거',
				],
			};
		},
		computed: {
			isModify() {
				return !!this.detail;
			},
			getLimitStr() {
				return key => {
					const { width, height } = this[`${key}ImgLimit`];
					return `${width} x ${height}`;
				};
			},
			getImgSrc() {
				return key =>
					this[key]
						? `${this.$store.state.env.IMAGE_HOST}${this[key]}`
						: '';
			},
			parsedPdtList() {
				return this.stamp_product_list.map(item => ({
					...item,
					isDisplayText: item.isDisplay ? '노출' : '미노출',
					isDiscontinueText: item.isDiscontinue ? '단종' : '정상',
				}));
			},
		},
		methods: {
			uploadImg(image, target) {
				this[target] = image.path;
			},
			addRemoveImg(key) {
				this.removeImgList.push(key);
			},
			toggleCommentModal() {
				this.$store.commit('modal/toggleModal', {
					id: 'StampCommentList',
				});
			},
			conditionInput(payload) {
				this.stamp_condition_list = this.stamp_condition_list.map(
					(item, idx) => {
						if (idx === payload.id) {
							Object.keys(payload).forEach(key => {
								if (key !== 'id') {
									item[this.conditionKeyMap[key]] =
										payload[key];
								}
							});
						}
						return item;
					}
				);
			},
			conditionDelete(idx) {
				const list = [...this.stamp_condition_list];
				if (list[idx].id) {
					list[idx].delete = true;
				} else {
					list.splice(idx, 1);
				}
				this.stamp_condition_list = list;
			},
			conditionAdd() {
				this.stamp_condition_list.push({
					title: '',
					sum_stamp: '',
					sum_winner: '',
				});
			},
			selectPdt(pdt) {
				if (!pdt) return;
				if (
					this.stamp_product_list.some(
						item => item.idProduct === pdt.idProduct
					)
				) {
					alert('이미 추가된 제품입니다.');
					return;
				}
				this.stamp_product_list.push({
					...pdt,
					temp: true,
				});
			},
			removePdt(idProduct) {
				this.stamp_product_list = this.stamp_product_list.filter(
					item => item.idProduct !== idProduct
				);
			},
			validate() {
				if (
					this.stamp_condition_list.some(
						item =>
							!item.sum_stamp || !item.title || !item.sum_winner
					)
				) {
					alert('당첨분류 내용을 모두 입력 해 주세요.');
					return false;
				}
				return true;
			},
			getParams() {
				const calendarOn = moment(this.calendar_on, 'YYYY-MM');
				const params = {
					type: '', // 고정값.. 대체 왜?
					has_comment: 1, // 고정값.. 대체 왜?
					calendar_on: this.calendar_on,
					start_on: calendarOn.toISOString(),
					finish_on: calendarOn.endOf('month').toISOString(),
					title: this.title,
					is_display: this.is_display,
					doc: [
						'calendar_background_image',
						'calendar_stamp_normal_image',
						'calendar_stamp_alternative_image',
						'calendar_color',
						'calendar_today_color',
					].reduce((acc, key) => {
						acc[key] = this[key];
						return acc;
					}, {}),
					content: this.content,
					reward_on: this.reward_on,
					stamp_condition_list: this.stamp_condition_list,
					comment_placeholder: this.comment_placeholder,
					stamp_product_list: this.stamp_product_list.map(item => ({
						product_id: item.idProduct,
					})),
				};
				if (this.isModify) {
					params.id = this.idStamp;
				}
				return params;
			},
			goBack() {
				if (document.referrer.indexOf('/event/stamp/list') > -1) {
					this.$router.go(-1);
				} else {
					this.$router.push('/event/stamp/list');
				}
			},
			async submit() {
				const isModify = this.isModify;
				try {
					if (!this.validate()) return;
					const params = this.getParams();
					await this.$axiosAdmin2.post('/v3/api/stamp', params);
					imageRemove(this.removeImgList);
					alert(
						`${isModify ? '수정' : '등록'}됐습니다. 리스트로 이동합니다.`
					);
					this.goBack();
				} catch (e) {
					console.error(e);
					if (isModify) {
						alert('수정에 실패했습니다.');
					} else {
						alert(
							'등록에 실패했습니다. 이미 해당 월의 출석체크 이벤트가 있는지 확인해주세요.'
						);
					}
				}
			},
			cancel() {
				if (!confirm('취소하고 리스트로 돌아갑니다.')) return;
				this.goBack();
			},
			setDetail() {
				const detail = this.detail;
				if (!detail) return;
				this.calendar_on = detail.calendar_on;
				this.calendar_background_image =
					detail.doc.calendar_background_image;
				this.calendar_stamp_normal_image =
					detail.doc.calendar_stamp_normal_image;
				this.calendar_stamp_alternative_image =
					detail.doc.calendar_stamp_alternative_image;
				this.title = detail.title;
				this.is_display = detail.is_display;
				this.calendar_today_color = detail.doc.calendar_today_color;
				this.calendar_color = detail.doc.calendar_color;
				this.content = detail.content;
				this.reward_on = detail.reward_on;
				this.stamp_condition_list = detail.stamp_condition_list;
				this.comment_placeholder = detail.comment_placeholder;
				this.stamp_product_list = detail.stamp_product_list;
			},
		},
		created() {
			this.setDetail();
		},
	};
</script>
<style lang="scss" scoped>
	.detail {
		min-width: 1504px;

		&__default {
			display: flex;
			width: 100%;
			margin-top: 24px;
		}

		&__default-section1 {
			width: 100%;
			min-width: 492px;
		}

		&__default-section2 {
			width: 100%;
			min-width: 386px;
			margin-top: 29px;
		}

		&__default-section3 {
			width: 100%;
			min-width: 626px;
			margin-top: 29px;
		}

		&__text-counter {
			width: 100%;
		}

		&__color-input {
			cursor: pointer;
		}

		&__pdt-list {
			margin-top: 16px;
			table-layout: fixed;
		}

		&__pdt-delete-button {
			color: red;
		}
	}
</style>
